// extracted by mini-css-extract-plugin
export default {"subtitleText":"PersonProjectRow-module__subtitleText___vOOli"};